import { EducationTags } from "../constants";

const vidSrcs = [
  "QmNH_5Qfgp4",
  "HzxbkYcJt4A",
  "YQeRZQWpYH4",
  "YH51XO8tLYw",
  "q-jFCfPRZhk",
  "dbROBUBUJkE",
  "dujwqCAkfMI",
  "l2xOdcKRuZQ",
];
export const vidData = [
  {
    src: vidSrcs[0],
    tags: [EducationTags.internships, EducationTags.university],
  },
  {
    src: vidSrcs[1],
    tags: [EducationTags.internships, EducationTags.university],
  },
  {
    src: vidSrcs[2],
    tags: [EducationTags.internships, EducationTags.skillDevelopment],
  },
  {
    src: vidSrcs[3],
    tags: [EducationTags.internships, EducationTags.university],
  },
  {
    src: vidSrcs[4],
    tags: [EducationTags.internships, EducationTags.university],
  },
  {
    src: vidSrcs[5],
    tags: [EducationTags.internships, EducationTags.whileYoureAtWork],
  },
  {
    src: vidSrcs[6],
    tags: [EducationTags.internships, EducationTags.university],
  },
  {
    src: vidSrcs[7],
    tags: [EducationTags.networking, EducationTags.university],
  },
];
